/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind =
  {
    Approve: "approve",
    Burn: "burn",
    Mint: "mint",
    Transfer: "transfer",
  } as const;
export type ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind =
  ClosedEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  >;

export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy =
  {
    Index: "index",
    MinusIndex: "-index",
    Amount: "amount",
    MinusAmount: "-amount",
    Timestamp: "timestamp",
    MinusTimestamp: "-timestamp",
    Kind: "kind",
    MinusKind: "-kind",
  } as const;
export type ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy =
  ClosedEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy
  >;

export type ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest =
  {
    ledgerCanisterId: string;
    id: string;
    /**
     * Only match values after this id
     */
    after?: Array<string> | undefined;
    /**
     * Only match values before this id
     */
    before?: Array<string> | undefined;
    limit?: number | undefined;
    includeKind?:
      | Array<
        ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
      >
      | undefined;
    start?: number | undefined;
    end?: number | undefined;
    sortBy?:
      | ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy
      | undefined;
  };

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  > = z.nativeEnum(
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind,
  );

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind
  > =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$ {
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema;
}

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$inboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy
  > = z.nativeEnum(
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy,
  );

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$outboundSchema:
  z.ZodNativeEnum<
    typeof ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy
  > =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$ {
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$inboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$outboundSchema;
}

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema:
  z.ZodType<
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    ledger_canister_id: z.string(),
    id: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    include_kind: z.array(
      ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$inboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sort_by:
      ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$inboundSchema
        .default("-index"),
  }).transform((v) => {
    return remap$(v, {
      "ledger_canister_id": "ledgerCanisterId",
      "include_kind": "includeKind",
      "sort_by": "sortBy",
    });
  });

/** @internal */
export type ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound =
  {
    ledger_canister_id: string;
    id: string;
    after?: Array<string> | undefined;
    before?: Array<string> | undefined;
    limit: number;
    include_kind?: Array<string> | undefined;
    start?: number | undefined;
    end?: number | undefined;
    sort_by: string;
  };

/** @internal */
export const ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema:
  z.ZodType<
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound,
    z.ZodTypeDef,
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest
  > = z.object({
    ledgerCanisterId: z.string(),
    id: z.string(),
    after: z.array(z.string()).optional(),
    before: z.array(z.string()).optional(),
    limit: z.number().int().default(20),
    includeKind: z.array(
      ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetIncludeKind$outboundSchema,
    ).optional(),
    start: z.number().optional(),
    end: z.number().optional(),
    sortBy:
      ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetSortBy$outboundSchema
        .default("-index"),
  }).transform((v) => {
    return remap$(v, {
      ledgerCanisterId: "ledger_canister_id",
      includeKind: "include_kind",
      sortBy: "sort_by",
    });
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$ {
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema` instead. */
  export const inboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema` instead. */
  export const outboundSchema =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema;
  /** @deprecated use `ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound` instead. */
  export type Outbound =
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$Outbound;
}

export function listAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequestToJSON(
  listAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest:
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
): string {
  return JSON.stringify(
    ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$outboundSchema
      .parse(
        listAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
      ),
  );
}

export function listAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema
        .parse(JSON.parse(x)),
    `Failed to parse 'ListAccountTransactionsApiV2LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest' from JSON`,
  );
}
